import { CARLINE_BRAND_NDPS, NEW_OR_USED_CAR_NDPS } from '../constants/carline-constants';
import { FIELD_NAME } from '../constants/form-constants';
import { formService } from '../form-service';
import { isComerciales } from '../helpers/carline-helpers';
import { getDealerId } from '../helpers/dealer-helpers';
import {
	fromConfiguradorFeatureApp,
	getFormName,
	getFormVersion,
	getParamsForm,
	hasOfertaFromExternalContent,
	isLayerForm,
	isLeadVentaCitaForm,
	isLeadVentaPresupuestoForm,
	isLeadVentaStockForm,
	isLeadVentaTestDriveForm,
	isLeadVentaVehiculoOcasionForm,
} from '../helpers/form-helpers';
import { dealerEntity } from './dealer-entity';
import { ofertaEntity } from './oferta-entity';
import { vehicleEntity } from './vehicle-entity';

class NdpsEntityClass {
	private static instance: NdpsEntityClass;
	private ndpsToken: string = '';

	private constructor() {}

	static getInstance(): NdpsEntityClass {
		if (!NdpsEntityClass.instance) {
			NdpsEntityClass.instance = new NdpsEntityClass();
		}
		return NdpsEntityClass.instance;
	}

	setToken(token: string) {
		this.ndpsToken = token;
	}

	get token(): string {
		return this.ndpsToken;
	}

	get brand(): string {
		return isComerciales() ? CARLINE_BRAND_NDPS.VOLKSWAGEN_COMERCIALES : CARLINE_BRAND_NDPS.VOLKSWAGEN;
	}

	get newOrUsedCar(): string {
		return isLeadVentaVehiculoOcasionForm() ? NEW_OR_USED_CAR_NDPS.USED_CAR : NEW_OR_USED_CAR_NDPS.NEW_CAR;
	}

	get originCategorization(): string {
		return isComerciales() ? '' : getDealerId() ? 'Dealer' : 'Brand';
	}

	get formObjective(): string {
		if (isLeadVentaPresupuestoForm()) {
			return 'Presupuesto';
		} else if (isLeadVentaTestDriveForm()) {
			return 'Test Drive';
		} else if (isLeadVentaStockForm()) {
			return 'Stock';
		} else {
			return 'Más Información';
		}
	}

	get formId(): string {
		return 'B09C01_LEM_WA1';
	}

	get sfLeadSalesInitialAction(): string {
		if (isComerciales()) {
			if (fromConfiguradorFeatureApp()) {
				return 'Direct to Sales Assistant';
			} else if (hasOfertaFromExternalContent()) {
				return 'Contact Center Qualification';
			} else if (isLeadVentaPresupuestoForm()) {
				return 'Direct to Sales Assistant';
			} else {
				return 'Contact Center Qualification';
			}
		} else {
			return 'Direct to Sales Assistant';
		}
	}

	get commentsBrand(): string {
		let comment = '';

		if (hasOfertaFromExternalContent()) {
			comment += ofertaEntity.promociones || '';
		}
		if (isLeadVentaStockForm()) {
			comment +=
				'Usuario interesado en vehículos de stock sin haber encontrado disponibilidad en el rango de KM seleccionados.';
		}
		if (isLeadVentaCitaForm()) {
			comment += 'Petición para reservar una cita en el punto de venta.';
		}
		if (this.originCategorization == 'Dealer') {
			comment += ' Lead dealerizado.';
		}
		return comment.trim();
	}

	get commonData(): Record<string, any> {
		const { device, tc, today, url } = getParamsForm();

		const rgpdPerfilado = formService.getFieldValue(FIELD_NAME.RGPD_PERFILADO);
		const rgpdComunicacionesComerciales = formService.getFieldValue(FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES);

		return {
			'headers[FORM_DATE_INSERTION]': today,
			'headers[FORM_URL]': url,
			'headers[ORIGIN_DEVICE_TYPE]': device,
			'headers[ORIGIN_TRACKING_CODE]': tc,
			'headers[FORM_NAME]': getFormName(true),
			'headers[FORM_VERSION]': getFormVersion(true),
			'headers[FORM_ID]': this.formId,
			'headers[FORM_OBJECTIVE]': this.formObjective,
			'headers[ORIGIN_CATEGORIZATION]': this.originCategorization,
			'fields[SF_LEAD_RECORDTYPE_ID]': '0121i000000D7NyAAK',
			'fields[SF_LEAD_RECORDTYPE_NAME]': 'Sales Assistant',
			'fields[SF_LEAD_SALES_INITIAL_ACTION]': this.sfLeadSalesInitialAction,
			'fields[DPS_BRAND]': this.brand,
			'fields[PERSON_RGPD_COM_COMERCIALES]': rgpdComunicacionesComerciales || 'NO INFORMADO',
			'fields[PERSON_RGPD_PERFILADO]': rgpdPerfilado || 'NO INFORMADO',
			'fields[COMMENTS_BRAND]': this.commentsBrand,
		};
	}

	get dealerData(): Record<string, any> {
		return {
			'fields[SF_LEAD_INSTALLATION_ID]': dealerEntity.id,
			'fields[SF_LEAD_INSTALLATION_CODE]': dealerEntity.code,
			'fields[SF_LEAD_INSTALLATION_NAME]': dealerEntity.name,
			'fields[SF_LEAD_INSTALLATION_ADDRESS]': dealerEntity.address,
			'fields[SF_LEAD_INSTALLATION_PROVINCE_CODE]': dealerEntity.provinceCode,
		};
	}

	get vehicleData(): Record<string, any> {
		const { url, referalUrl } = getParamsForm();

		return {
			'fields[VEH_INTEREST_BRAND]': this.brand,
			'fields[VEH_INTEREST_ID]': vehicleEntity.vehicleCode,
			'fields[VEH_INTEREST_MODEL]': vehicleEntity.carlineTitle,
			'fields[VEH_INTEREST_FUEL]': vehicleEntity.fuelType,
			'fields[VEH_INTEREST_NEW_OR_USED]': this.newOrUsedCar,
			'fields[VEH_INTEREST_LINK]': isLayerForm() ? url : referalUrl,
			'fields[VEH_INTEREST_SALESGROUP]': vehicleEntity.salesgroupTitle,
			'fields[VEH_INTEREST_SALESGROUP_ID]': vehicleEntity.salesgroupCode,
			'fields[VEH_INTEREST_DETAILS]': vehicleEntity.motorizacion,
			'fields[VEH_INTEREST_TRIM_LINE]': vehicleEntity.trimlineName,
			'fields[VEH_INTEREST_CONFIGURATION_CODE]': vehicleEntity.marketingCode,
		};
	}
}

export const ndpsEntity = NdpsEntityClass.getInstance();
